module.exports = __webpack_public_path__ + "static/img/11.1df0766.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/11.png
// module id = Jm0T
// module chunks = 0